import { Directive, Input, OnInit, EventEmitter, HostListener } from '@angular/core';
import { FileClass } from './file.class';
import { FilesProvider, FileRaw, ImageReadyService } from './providers/';
@Directive({
  selector: 'file-view-base'
})

export class FileViewBase {
  @Input() file: FileClass;
  public readyChange: EventEmitter<boolean>;
  private _ready: boolean = false;
  constructor(public fp: FilesProvider, public irs: ImageReadyService) {
    this.readyChange = new EventEmitter<boolean>();
  }

  @Input() get ready(): boolean {
    return this._ready;
  }

  set ready(value: boolean) {
    this._ready = value;
    this.readyChange.emit(value);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (typeof(this.resized) === 'function') {
      this.resized(event);
    }
  }

  loadFileBlob() {
    this.fp.getFile(this.file.id, this.file.mime, this.file.name).subscribe((url: any) => {
      if (!url) {
        return false;
      }
      this.fileLoaded(url);
    });
  }

  fileLoaded(blob: any) {
  }

  resized(event?:any) {}
}



// WEBPACK FOOTER //
// ./src/app/file.view.directive.ts